import format from "date-fns/format";
import { bs, ca, de, enUS, es, fr, he, it, ko, pl, pt, uk, zhCN } from "date-fns/locale";

const locales = { "en": enUS, de, es, "uk-UA": uk, pl, fr, he, it, pt, ca, "zh": zhCN, bs, ko };
export type DateLike = Date | number | string | undefined | null;

export interface useDateOptions {
  date: DateLike;
  formatStr: string;
  locale: TAvailableLocale;
}

/**
 * Normalizes the given date-like value to a Date object.
 *
 * @param {DateLike} date - The date-like value to be normalized.
 * @returns {Date} The normalized Date object.
 */
export function normalizeDate(date: DateLike) {
  if (date === null)
    return new Date(Number.NaN); // null is invalid

  if (date === undefined)
    return new Date();

  return new Date(date);
}

/**
 * Formats the given date using the specified format and locale.
 *
 * @param {DateLike} date - The date-like value to be formatted.
 * @param {string} formatStr - The format string for formatting the date.
 * For available format options, see: {@link https://date-fns.org/v2.16.1/docs/format}
 * @param {TAvailableLocale} locale - The locale used for formatting the date.
 * @returns {string} The formatted date string.
 */
export default function formatDate(date: DateLike, formatStr: string, locale: TAvailableLocale = "en"): string {
  const normalizedDate = normalizeDate(date);

  const dateLocale = locales[locale];

  return format(normalizedDate, formatStr, { locale: dateLocale });
}
